import { Group, Image, useMantineTheme, Button } from '@mantine/core';
import UserMenu from './UserMenu';
import { useWeb3Context } from '../../providers/Web3Provider/useWeb3Context';
import { useRouter } from 'next/router';
import { useMediaQuery } from '@mantine/hooks';
import { usePrivy, useWallets } from '@privy-io/react-auth';

const Navbar = () => {
  const web3ProviderContext = useWeb3Context();
  const router = useRouter();
  const theme = useMantineTheme();
  const isXsScreen = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);
  const { ready: walletsReady } = useWallets();
  const { authenticated, login, ready } = usePrivy();
  const showLoginButton = (!web3ProviderContext?.isConnected && ready) || !authenticated;
  return (
    <Group h="100%" align="center" justify="space-between">
      <Group
        style={{ cursor: 'pointer' }}
        onClick={() => {
          router.push('/');
          if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
          }
        }}
      >
        <Image
          src={isXsScreen && authenticated ? '/favicon.svg' : '/Rankify_White@2x.png'}
          alt="Rankify"
          w="100%"
          maw={123}
          h={36}
          fit="contain"
        />
      </Group>
      <Group gap="xs">
        {!showLoginButton && web3ProviderContext.account ? (
          <>
            <UserMenu web3ProviderContext={web3ProviderContext} userAddress={web3ProviderContext.account} />
          </>
        ) : (
          <Button
            size="xs"
            disabled={!ready || (ready && authenticated)}
            loading={!walletsReady}
            onClick={() => {
              login();
            }}
          >
            Login
          </Button>
        )}
      </Group>
    </Group>
  );
};

export default Navbar;
